const DETAILED_PRO_ALLOWED_COM_ID_LIST = [
  'B068366F-5EB8-1C7E-E79C-D438C8E32F9D',
  '721C8B3F-1A9E-4B3E-855A-B7B8CE624167',
  '246AB769-F512-446D-B3A6-60DD0726AD35',
  '5FEC5FBB-AD6F-4FA0-80F8-445D5A892530',
  'F0C2775D-D815-458B-A2AD-71FFDDC24C2D'
];
export const isDetailedSikdaeProAllowedCompany = (companyId) => DETAILED_PRO_ALLOWED_COM_ID_LIST.includes(companyId);
